<template>
    <div
        class="min-h-screen flex sm:justify-center pt-6 sm:pt-0 overflow-hidden"
    >
        <v-container class="flex justify-center align-center upper-third">
            <v-col cols="12" sm="10" md="8" lg="6" class="justify-center">
                <v-img
                    v-bind:src="'/musicologie-wordmark.webp'"
                    max-width="200"
                    class="mx-auto"
                />
                <lottie-player
                    src="https://assets7.lottiefiles.com/packages/lf20_pNx6yH.json"
                    background="transparent"
                    speed="1"
                    style="width: 300px; height: 300px"
                    loop
                    autoplay
                    class="mx-auto"
                ></lottie-player>
                <v-container style="max-width: 400px">
                    <v-card-title class="soli-grey">{{ title }}</v-card-title>
                    <v-card-subtitle class="soli-grey flex">{{
                        errors.length ? errors : description
                    }}</v-card-subtitle>

                    <v-card-subtitle
                        class="soli-grey"
                        v-if="status === 500 || status === 503"
                        >For internet points and eternal gratitude, please
                        contact
                        <a
                            class="soli-blue-text"
                            :href="`mailto:${
                                $page.props.staffView ? 'kyle' : 'feedback'
                            }@musicologie.com`"
                            >{{
                                $page.props.staffView ? "kyle" : "feedback"
                            }}@musicologie.com</a
                        >
                    </v-card-subtitle></v-container
                >
            </v-col>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        status: Number,
        errors: {},
    },
    computed: {
        title() {
            return {
                503: "503: Service Unavailable",
                500: "500: Server Error",
                404: "404: Page Not Found",
                403: "403: Missing Permissions",
            }[this.status];
        },
        description() {
            return {
                503: "Sorry, we are doing some maintenance. Please check back soon.",
                500: "Whoops, something went wrong on our servers",
                404: "Sorry, the page you are looking for could not be found.",
                403: "Sorry, you are missing permissions to view this page.",
            }[this.status];
        },
    },
    mounted() {
        if (document.querySelector("#lottie")) return;
        let lottie = document.createElement("script");
        lottie.setAttribute(
            "src",
            "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
        );
        lottie.id = "lottie";
        document.head.appendChild(lottie);
        console.log(this.errors);
    },
};
</script>
